import { useTranslation } from 'react-i18next';

export default function Benefits() {
  const { t } = useTranslation();

  const benefits = [
    { icon: 'ri-plant-line',       title: t('benefit1Title'), description: t('benefit1Text') },
    { icon: 'ri-train-line',       title: t('benefit2Title'), description: t('benefit2Text') },
    { icon: 'ri-water-flash-line', title: t('benefit3Title'), description: t('benefit3Text') },
    { icon: 'ri-hotel-bed-line',   title: t('benefit4Title'), description: t('benefit4Text') },
    { icon: 'ri-heart-line',       title: t('benefit5Title'), description: t('benefit5Text') },
    { icon: 'ri-map-2-line',       title: t('benefit6Title'), description: t('benefit6Text') },
  ];

  return (
    <section className="py-12 sm:py-20 px-4 sm:px-6 bg-stone-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-gray-800 mb-4">
            {t('benefitsTitle')}
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            {t('benefitsLead')}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white p-4 sm:p-8 rounded-lg hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-9 h-9 sm:w-14 sm:h-14 flex items-center justify-center bg-amber-100 rounded-full mb-3 sm:mb-6">
                <i className={`${benefit.icon} text-base sm:text-2xl text-amber-700`}></i>
              </div>
              <h3 className="text-sm sm:text-xl font-semibold text-gray-800 mb-1.5 sm:mb-3">
                {benefit.title}
              </h3>
              <p className="text-xs sm:text-base text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
